module.exports = __webpack_public_path__ + "media/newstyle/images/library_music-24cbb2a8a9209a7b23c81eedfa33868d.svg";